module.exports = __webpack_public_path__ + "static/media/image7.8167caf2.png";